import { arrayify } from '~/components/util'

export const onUseResource = (
  resource: Ref<string | string[]>,
  callback: (resource: string, amount: number) => any
) => {
  onBodyEvent('UseResource', (ev: CustomEvent) => {
    const resources = arrayify(resource.value)
    const name = ev?.detail?.name
    const amount = ev?.detail?.amount ?? 1
    if (resources.includes(name)) {
      callback(name, amount)
    }
  })
}
